import { LoadableAfterPaint } from '@confluence/loadable';

export const ExternalCollaboratorUserLozenge = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExternalUserLozenge" */ '../src/ExternalUserLozenge.tsx'
			)
		).ExternalUserLozenge,
});
